import React, { useState } from 'react';
import { Keyvaults, Namespace } from '@app/SecretManager/SecretsExplorer/model/repository';
import { useParams } from 'react-router-dom';
import useSecretDetails from './useSecretDetails';
import SecretDetails from './SecretDetails';
import { useUnsealSecret } from '../../hooks/useSecretManagerData';

const FileDetailsPage: React.FunctionComponent<{ namespaces: Namespace[], keyvaults: Keyvaults, root: string }> = ({ namespaces, keyvaults, root }) => {
  const { namespace_name, application_name, container_name, file_path } = useParams<{ namespace_name: string, application_name: string, container_name: string, file_path: string }>();

  const [isValueHidden, setIsValueHidden] = useState(true);
  const [secretValue, setSecretValue] = useState<string | undefined>(undefined);

  const unsealMutation = useUnsealSecret();

  const { item: file, usedBy, history, canReveal, isLoading, error } = useSecretDetails(
    namespaces,
    keyvaults,
    namespace_name,
    application_name,
    container_name,
    decodeURIComponent(file_path),
    true,
  );

  if (isLoading) {
    return <div>Loading...</div>;
  }

  const fetch_secret = async () => {
    const data = { vault: file!.keyvault_key_ref.keyvault_name, name: file!.keyvault_key_ref.keyvault_key };
    const result = await unsealMutation.mutateAsync(data);
    setSecretValue(result.value);
  };

  const toggleValueVisibility = async () => {
    const next_state = !isValueHidden;
    if (!next_state && secretValue === undefined) {
      await fetch_secret();
    }
    setIsValueHidden(next_state);
  };

  return (
    <SecretDetails
      root={root}
      namespaceName={namespace_name}
      applicationName={application_name}
      containerName={container_name}
      itemName={decodeURIComponent(file_path)}
      item={file}
      isFile={true}
      usedBy={usedBy}
      history={history}
      toggleValueVisibility={toggleValueVisibility}
      isValueHidden={isValueHidden}
      secretValue={secretValue}
      canReveal={canReveal}
      loading={unsealMutation.isPending}
      error={error}
    />
  );
};

export { FileDetailsPage };
